import server from "../Server";
import { ResetPasswordPayload } from "../../../gateways";
import withErrorCheck from "../CheckError";

export const ResetPassword = async (params: ResetPasswordPayload): Promise<boolean> => {
  withErrorCheck(
    await server.auth.setSession({ access_token: params.access_token, refresh_token: params.refresh_token })
  );
  const { user } = withErrorCheck(await server.auth.updateUser({ password: params.password }));
  await server.auth.signOut();
  return !!user;
};
